import React from "react";
import PredictionPage from "../../components/PredictionPage";

function AUDJPY() {
  return (
    <PredictionPage
      title="AUDJPY"
      content="This is the AUDJPY AI Trading Predictions page."
      canonical="/forex-minors/audjpy-ai-trading-predictions"
      categoryKey="nav.forexMinors"
      categoryPath="/forex-minors"
      symbol="AUDJPY"
    />
  );
}

export default AUDJPY;
